<div class="ac-page c7-access-view c7-access-privacy">

  <header class="ac-topbar">
    <div class="ac-topbar__inner">
      <app-back-button></app-back-button>
      <a class="ac-brand" href="javascript:void(0)" aria-label="CULTURA">
        <img src="assets/logo-blue.png" alt="CULTURA" class="ac-brand__logo" />
      </a>
      <label class="ac-lang">
        <span>{{ "acceptPage.language" | translate }}</span>
        <select [value]="selectedLanguage" (change)="changeLanguage($any($event.target).value)">
          <option *ngFor="let language of supportedLanguages" [value]="language.code">{{ language.name }}</option>
        </select>
      </label>
    </div>
  </header>

  <main class="ac-main ac-main--center ac-main--top">
    <article class="ac-card ac-card--doc" aria-labelledby="ac-privacy-title">
      <h1 id="ac-privacy-title">{{ "signup.Termsandconditions.PrivacyPolicyforculturatools" | translate }}</h1>

      <div class="ac-doc__body" *ngIf="documentHtml" [innerHTML]="documentHtml"></div>

      <ng-container *ngIf="!documentHtml">
      <section class="ac-doc__section">
        <h2>{{ "signup.Termsandconditions.DataController" | translate }}</h2>
        <p>{{ "signup.Termsandconditions.DataControllerContent" | translate }}</p>
      </section>

      <section class="ac-doc__section" *ngFor="let section of sections">
        <h2>{{ "signup.Termsandconditions." + section[0] | translate }}</h2>
        <p>{{ "signup.Termsandconditions." + section[1] | translate }}</p>
      </section>

      <p class="ac-doc__footer">{{ "signup.Termsandconditions.footer" | translate }}</p>
      </ng-container>
      <div class="ac-doc__back"><app-back-button></app-back-button></div>
    </article>
  </main>

  <app-auth-footer></app-auth-footer>
</div>
